const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 8.12501C12.5 11.25 10.3125 12.8125 7.7125 13.7188C7.57635 13.7649 7.42846 13.7627 7.29375 13.7125C4.6875 12.8125 2.5 11.25 2.5 8.12501V3.75001C2.5 3.58425 2.56585 3.42528 2.68306 3.30807C2.80027 3.19086 2.95924 3.12501 3.125 3.12501C4.375 3.12501 5.9375 2.37501 7.025 1.42501C7.15741 1.31189 7.32585 1.24973 7.5 1.24973C7.67415 1.24973 7.84259 1.31189 7.975 1.42501C9.06875 2.38126 10.625 3.12501 11.875 3.12501C12.0408 3.12501 12.1997 3.19086 12.3169 3.30807C12.4342 3.42528 12.5 3.58425 12.5 3.75001V8.12501Z",
    stroke: "#8A94A3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.625 7.5L6.875 8.75L9.375 6.25",
    stroke: "#8A94A3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.51ecc9ee38958d82e095902308b1d1ec.svg";
export { ForwardRef as ReactComponent };